/*
  This function takes a string and will capitalize each word in the string.
  e.g. capitalizeWords('the city) returns 'The City'.
*/

const capitalizeWords = (str) => str.replace(/(?:^|\s)\S/g, (l) => l.toUpperCase());

export default capitalizeWords;
